import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationMethylationCombined from "./index";

const MethylationMethylationWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationMethylationCombined}
    keyControlsId="methylation-methylation-key"
    {...props}
  />
);

export default MethylationMethylationWithToggleKey;
